// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kyja8LY2oQuei5lJ4TnR{flex-direction:column;gap:16px;padding-top:12px;display:flex}.B_mQXUULtUYBgoXm8Itk{margin-right:-4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `kyja8LY2oQuei5lJ4TnR`,
	"rightIcon": `B_mQXUULtUYBgoXm8Itk`
};
export default ___CSS_LOADER_EXPORT___;
